// ABOUTME: Dialog for adding a new product to the global configuration.
// ABOUTME: Includes fields for product ID, name, and optional category selection.

import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { colors } from '../../theme/colors';

export default function AddProductDialog({ open, onClose, onSave, categories = [] }) {
  const { t } = useTranslation();
  const [productId, setProductId] = useState('');
  const [name, setName] = useState('');
  const [category, setCategory] = useState('');

  useEffect(() => {
    if (open) {
      setProductId('');
      setName('');
      setCategory('');
    }
  }, [open]);

  const handleSave = () => {
    const data = {
      product_id: Number(productId),
      name,
    };
    if (category) {
      data.category = category;
    }
    onSave(data);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: '12px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)' }
      }}
    >
      <DialogTitle>
        <Typography sx={{ fontSize: '1rem', fontWeight: 600, color: colors.text.primary }}>
          {t('config.product.addProduct')}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
          <TextField
            label={t('config.product.productId')}
            size="small"
            type="number"
            value={productId}
            onChange={(e) => setProductId(e.target.value)}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
          />
          <TextField
            label={t('config.product.productName')}
            size="small"
            value={name}
            onChange={(e) => setName(e.target.value)}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
          />
          <FormControl size="small">
            <InputLabel>{t('config.fields.category')}</InputLabel>
            <Select
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              label={t('config.fields.category')}
              sx={{ borderRadius: '8px' }}
            >
              <MenuItem value="">-</MenuItem>
              {categories.map(cat => (
                <MenuItem key={cat.id} value={cat.id}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box sx={{
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      backgroundColor: cat.color || colors.category.default,
                    }} />
                    {cat.name || cat.id}
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ textTransform: 'none' }}>
          {t('config.cancel')}
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={!productId || !name}
          sx={{
            textTransform: 'none',
            bgcolor: colors.ui.button,
            borderRadius: '8px',
            '&:hover': { bgcolor: colors.ui.buttonHover },
          }}
        >
          {t('config.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
